import { Text } from "@mantine/core";
import { forwardRef } from "react";
import { rankContacts, searchContacts } from "utils/contactSearch";

// Shared by the assistant widgets that pick people (email recipients and
// calendar attendees), so they suggest the same people as the guest picker.

// The dropdown keeps data order, so frequent, recent people go first.
export const createDirectoryOptions = (contacts) =>
  rankContacts(contacts).map((contact) => ({
    value: contact.email,
    label: contact.name || contact.email,
  }));

// Same word-start rule as the guest picker: "chen", "acme" and "sc44" all
// find sc4471@acmefoods.com once we know their name. Before the user types,
// every unselected option shows, most active people first.
export const filterRecipient = (query, selected, item) => {
  if (selected) return false;
  if (!query.trim()) return true;
  return searchContacts([{ email: item.value, name: item.label }], query).length > 0;
};

export const RecipientOption = forwardRef(({ label, value, ...others }, ref) => (
  <div ref={ref} {...others}>
    <Text size="sm">{label}</Text>
    {label !== value && (
      <Text size="xs" color="dimmed">
        {value}
      </Text>
    )}
  </div>
));
RecipientOption.displayName = "RecipientOption";
